import React from 'react';
import './ThingsPage.css'; // Import the CSS file
import Navbar from './navbar/Navbar';
import Footer from './footer/Footer';
import CulturalExperiences from './thingsSlider/CulturalExperiences';
import DiningExperiences from './thingsSlider/DiningExperiences';
import RecreationalActivities from './thingsSlider/RecreationalActivities';
import ShoppingMarket from './thingsSlider/ShoppingMarket';
import FestivalsBacoor from './thingsSlider/FestivalsBacoor';
import ThingsIntroduction from './sliders/ThingsIntroduction';



const ThingsPage = () => {
  return (
    <div className="events-page">
      <Navbar />
      <ThingsIntroduction/>
      <RecreationalActivities />
      <DiningExperiences />
      <ShoppingMarket />

      <Footer />
    </div>
  );
};

export default ThingsPage;
